import { useContext } from "react";
import { useParams } from "react-router-dom";
import Frame from "../Frames/Basic";
import Signature from "../Signature/Signature";
import UserContext from "../../services/Context/UserContext"

export default function Agreement(){

    const {id} = useParams()

    const {user} = useContext(UserContext)

    return <Frame>
        
        <Signature 
            data={{
                title: 'Contrat de formation professionnelle',
                document: 'agreement',
                reference: id,
                name: user.name,
                email: user.email,
                phone: user.phone,
                canvas: false
            }}
        />

    </Frame>


}